<template>
  <span>
    <div v-if="props.model && props.isDisabled" :class="'button-disabled ' + (className ?? '')">
      <Icon :model="props.model" :alt="props.alt" :key="componentKey" />
      <span v-if="props.text" class="button-text">{{ props.text }}</span>
    </div>

    <div
      v-if="props.model && !props.isDisabled"
      :class="'button ' + (className ?? '')"
      @click="click"
    >
      <Icon :model="props.model" :alt="props.alt" :key="componentKey" />
      <span v-if="props.text" class="button-text">{{ props.text }}</span>
    </div>
  </span>
</template>

<script setup lang="ts">
import type { Button } from '../types/configuration/Button'
import { updateComponentKey } from '../composables/ComponentKey'
import Icon from './Icon.vue'

const props = defineProps<{
  model: Button | undefined
  alt: string | undefined
  isDisabled: boolean
  className?: string
  text?: string
  click?: () => void
}>()

let componentKey = updateComponentKey(props)
</script>

<style scoped lang="scss">
.button,
.button-disabled {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.button-disabled {
  pointer-events: 'none';
  opacity: 0.5;
}
.button {
  cursor: pointer;
}
</style>
